import Vue from 'vue'
import VueResource from 'vue-resource'
import VueIntercom from 'vue-intercom'
import 'jquery'
import _ from 'lodash'
import App from './App'
import { createRouter } from './router'
import BrowserPage from '@/views/home/browser'
import store from './store'
import Vuetify from 'vuetify'
import VueNumeric from 'vue-numeric'
import VueClipboard from 'vue-clipboard2'
import VueHead from 'vue-head'
import VeeValidate from 'vee-validate'
import SocialSharing from 'vue-social-sharing'
import VueLazyload from 'vue-lazyload'
import 'fullpage.js/vendors/scrolloverflow'
import 'fullpage.js/dist/fullpage.css'
import VueFullPage from 'vue-fullpage.js'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("ApexChart", VueApexCharts);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
import { directive as onClickOutside } from 'vue-on-click-outside'
import { Filter } from './helper'

import SettingService from './services/setting'
import '@/../static/styles/app.scss'

Vue.config.productionTip = false
Object.defineProperty(Vue.prototype, '_', { value: _ })
Vue.use(VueResource)
Vue.use(VueIntercom, { appId: process.env.INTERCOM_APP_ID })
Vue.use(Vuetify)
Vue.use(VueNumeric)
Vue.use(VueClipboard)
Vue.use(VueHead)
Vue.use(SocialSharing)
Vue.use(VueLazyload)
Vue.use(VueFullPage)
Vue.use(VueCtkDateTimePicker)

const dictionary = {
  en: {
    custom: {
      username: {
        regex: 'Username cannot have special char.',
      },
    },
  },
}
VeeValidate.Validator.localize('en', dictionary.en)
Vue.use(VeeValidate)

Vue.directive('on-click-outside', onClickOutside)

Vue.filter('formatSlashedDate', Filter.formatSlashedDate)
Vue.filter('formatDate', Filter.formatDate)
Vue.filter('formatDateFromNow', Filter.formatDateFromNow)
Vue.filter('formatDateFromNowShort', Filter.formatDateFromNowShort)
Vue.filter('formatNumber', Filter.formatNumber)
Vue.filter('formatNumberWithComma', Filter.formatNumberWithComma)
Vue.filter('formatLargeNumber', Filter.formatLargeNumber)
Vue.filter('formatFullUrl', Filter.formatFullUrl)
Vue.filter('getTime', Filter.getTime)
Vue.filter('timeInHours', Filter.timeInHours)
Vue.filter('timeInMinutes', Filter.timeInMinutes)
Vue.filter('timeInWords', Filter.timeInWords)
Vue.filter('capitalize', Filter.capitalize)
Vue.filter('truncateInMiddle', Filter.truncateInMiddle)
Vue.filter('pluralize', Filter.pluralize)
Vue.filter('toLocalTimeString', Filter.toLocalTimeString)

navigator.sayswho = (function () {
  let ua = navigator.userAgent
  let tem
  let M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return 'IE ' + (tem[1] || '')
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
  return M.join(' ')
})()

let isOldBrowser = false
const browserInfo = navigator.sayswho.split(' ')
const browserName = browserInfo[0].toLowerCase()
const browserVersion = parseInt(browserInfo[1]) || 0
switch (browserName) {
  case 'chrome':
    if (browserVersion < 64) isOldBrowser = true
    break
  case 'firefox':
    if (browserVersion < 60) isOldBrowser = true
    break
  case 'safari':
    if (browserVersion < 10) isOldBrowser = true
    break
  case 'ie':
    if (browserVersion < 11) isOldBrowser = true
    break
  case 'opera':
    if (browserVersion < 50) isOldBrowser = true
    break
  case 'qq':
    if (browserVersion < 6) isOldBrowser = true
    break
}

const isMobile = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}
const onMobile = isMobile()

if (isOldBrowser) {
  const app = new Vue({
    template: '<BrowserPage/>',
    components: { BrowserPage },
  })
  app.$mount('#app')
} else {
  SettingService.getSettings().then((response) => {
    const settings = response.body
    const router = createRouter(settings)
    router.beforeEach((to, from, next) => {
      const isAllowedOnMobile = to.meta.allowOnMobile;
      if (onMobile && !isAllowedOnMobile) {
        return next({
          name: "Home",
          replace: true,
        })
      }

      if (
        /^\/(x)$/.test(to.path) &&
        store.state.auth.secret_code !== process.env.SECRET_CODE
      ) {
        next('/protect')
      } else {
        next()
      }
    })
    const app = new Vue({
      router,
      store,
      template: '<App/>',
      components: { App },
    })
    app.$mount('#app')
  })
}



// WEBPACK FOOTER //
// ./src/main.js